// if (!customElements.get('g-localization-form-modal')) {
//   class MLocalizationForModal extends HTMLElement {
//     constructor() {
//       super();
//       this.selectors = {
//         trigger: '.g-select-custom--trigger',
//         modal: '.select-modal',
//         selectCountry: '.g-select-country',
//         countryItems: ['.select-country-item'],
//         group: ['[data-group]'],
//       };
//       this.form = this.closest('[data-localization-form]');
//       this.domNodes = queryDomNodes(this.selectors, this);
//       this.countryMap = {
//         'North America': 'US,CA,MX',
//         Europe: 'DE,GB,FR,IE,CH,IT,AT,NL,ES,PL,FI,HU,SE,BE,GR,CZ,DK,NO,PT,SI,LU,SK',
//         'Asia Pacific': 'AU,JP,IN,SG,NZ,PH,HK,MY,ID,ZA,TH,KR',
//         'Middle East': 'AE,SA',
//       };
//     }
//     connectedCallback() {
//       this.init();
//       this.sortDom();
//     }
//     init() {
//       this.domNodes.trigger && this.domNodes.trigger.addEventListener('click', this.openModal.bind(this));
//       this.domNodes.countryItems &&
//         this.domNodes.countryItems.forEach((dom) => {
//           dom.addEventListener('click', this.chooseCountry.bind(this));
//         });
//     }
//     openModal() {
//       this.domNodes.modal.open();
//       this.domNodes.selectCountry.classList.remove('g:hidden');
//     }
//     chooseCountry(e) {
//       let value = e.target.closest('.select-country-item').dataset.iso;
//       const countryInput = this.form.querySelector('input[name="country_code"]');
//       countryInput && countryInput.setAttribute('value', value); // 如果需要以不同的方式映射，可以在此处修改逻辑
//       this.form.submit();
//       this.domNodes.modal.close();
//     }
//     sortDom() {
//       //添加到group-Dom的后面
//       this.domNodes.group.forEach((dom) => {
//         const group = dom.dataset.group;
//         const items = this.domNodes.countryItems.filter((item) => {
//           return this.countryMap[group].includes(item.dataset.iso);
//         });
//         if (items.length == 0) {
//           dom.style.display = 'none';
//           return;
//         }
//         //添加到下一个兄弟节点
//         let temp = dom;
//         items.forEach((item) => {
//           requestAnimationFrame(() => {
//             insertAfter(item, temp);
//             temp = item;
//           });
//         });
//       });

//       function insertAfter(newElement, targetElement) {
//         const parent = targetElement.parentNode;

//         if (parent.lastChild === targetElement) {
//           // 如果 targetElement 是父节点的最后一个子节点
//           parent.appendChild(newElement);
//         } else {
//           // 否则，插入到 targetElement 的下一个兄弟节点之前
//           parent.insertBefore(newElement, targetElement.nextSibling);
//         }
//       }
//     }
//   }
//   customElements.define('g-localization-form-modal', MLocalizationForModal);
// }
if (!customElements.get('g-localization-form-modal')) {
  class MLocalizationForModal extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        trigger: '.g-select-custom--trigger',
        modal: '.select-modal',
        selectCountry: '.g-select-country',
        countryItems: ['.select-country-item'],
        group: ['[data-group]'],
      };
      this.form = this.closest('[data-localization-form]');
      this.domNodes = queryDomNodes(this.selectors, this);
      this.countryMap = {
        'North America': 'US,CA,MX',
        Europe: 'DE,GB,FR,IE,CH,IT,AT,NL,ES,PL,FI,HU,SE,BE,GR,CZ,DK,NO,PT,SI,LU,SK,BG,HR,EE,LV,LT,RO',
        'Asia Pacific': 'AU,JP,IN,SG,NZ,PH,HK,MY,ID,ZA,TH,KR,TW,VN',
        'Middle East': 'AE,SA,BH,IL,JO,OM,QA,TR',
      };
    }
    connectedCallback() {
      this.init();
      this.sortDom();
    }
    init() {
      this.domNodes.trigger && this.domNodes.trigger.addEventListener('click', this.openModal.bind(this));
      this.domNodes.countryItems &&
        this.domNodes.countryItems.forEach((dom) => {
          dom.addEventListener('click', this.chooseCountry.bind(this));
        });
    }
    openModal() {
      this.domNodes.modal.open();
      this.domNodes.selectCountry.classList.remove('g:hidden');
    }
    chooseCountry(e) {
      // 获取选择的国家值
      let value = e.target.closest('.select-country-item').dataset.iso;

      // 禁用修改 URL 或输入框的操作，仅为示例，您可以根据需求自定义
      // const countryInput = this.form.querySelector('input[name="country_code"]');
      // countryInput && countryInput.setAttribute('value', value); // 不需要更新输入框的值

      // 这里可以选择更改外观或者标记选择的国家，但不提交任何数据或刷新页面
      // 比如可以更改触发器的文本，或者更换选择的旗帜
      this.domNodes.trigger.innerHTML = `<span class="g-country-flags g-country-flags--${value}"></span>`; // 仅示例，您可以按需求更改内容

      // 关闭模态框，不需要刷新页面
      this.domNodes.modal.close();
    }
    sortDom() {
      // 添加到group-Dom的后面
      this.domNodes.group.forEach((dom) => {
        const group = dom.dataset.group;
        const items = this.domNodes.countryItems.filter((item) => {
          return this.countryMap[group].includes(item.dataset.iso);
        });
        if (items.length == 0) {
          dom.style.display = 'none';
          return;
        }
        // 添加到下一个兄弟节点
        let temp = dom;
        items.forEach((item) => {
          requestAnimationFrame(() => {
            insertAfter(item, temp);
            temp = item;
          });
        });
      });

      function insertAfter(newElement, targetElement) {
        const parent = targetElement.parentNode;

        if (parent.lastChild === targetElement) {
          // 如果 targetElement 是父节点的最后一个子节点
          parent.appendChild(newElement);
        } else {
          // 否则，插入到 targetElement 的下一个兄弟节点之前
          parent.insertBefore(newElement, targetElement.nextSibling);
        }
      }
    }
  }
  customElements.define('g-localization-form-modal', MLocalizationForModal);
}

